import { render, staticRenderFns } from "./export_countries.vue?vue&type=template&id=bf3fe8a0&scoped=true"
import script from "./export_countries.vue?vue&type=script&lang=js"
export * from "./export_countries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3fe8a0",
  null
  
)

export default component.exports